import { queryApi } from "src/utils/api/ApiMethods"
import { buildQueryString } from "src/utils/api/query_param_helpers"

export const getServiceProducts = (
  marinaSlug,
  { availability, q, page = 1, perPage = 25 }
) => {
  const qs = buildQueryString({
    availability,
    q,
    page,
    per_page: perPage,
  })
  return queryApi(`/manage/${marinaSlug}/service/products.json${qs}`).then(
    (response) => response.data
  )
}
